import React from 'react';
import styles from './mobile-side-panel-bar.module.css';

// Kept in sync with .bar's height in mobile-side-panel-bar.module.css —
// consumers whose content sits above this fixed bar (e.g. MobileDashboardShell)
// pad by this amount so it isn't covered.
export const MOBILE_SIDE_PANEL_BAR_HEIGHT_PX = 52;

export interface MobileSidePanelBarItem {
  id: string;
  icon: React.ReactNode;
  label: string;
  active: boolean;
  onClick: () => void;
}

export default function MobileSidePanelBar({ items }: { items: MobileSidePanelBarItem[] }) {
  return (
    <div className={styles.bar}>
      {items.map(item => (
        <button
          type={'button'}
          key={item.id}
          className={`${styles.barTab} ${item.active ? styles.barTabActive : ''}`}
          onClick={item.onClick}
          title={item.label}
        >
          {item.icon}
        </button>
      ))}
    </div>
  );
}
